import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';

const CentralNexus = ({ activeProject, onNavigate }) => {
  const [rotation, setRotation] = useState(0);
  const [pulseIntensity, setPulseIntensity] = useState(0.5);

  useEffect(() => {
    const interval = setInterval(() => {
      setRotation(prev => (prev + 0.5) % 360);
      setPulseIntensity(0.3 + Math.sin(Date.now() * 0.003) * 0.2);
    }, 50);

    return () => clearInterval(interval);
  }, []);

  const navigationItems = [
    { name: 'Portfolio', route: '/interactive-portfolio-gallery', icon: 'Briefcase', color: '#00d4ff' },
    { name: 'Process', route: '/process-laboratory', icon: 'Beaker', color: '#ff6b35' },
    { name: 'Skills', route: '/skill-constellation', icon: 'Star', color: '#00ff88' },
    { name: 'Contact', route: '/contact-nexus', icon: 'MessageCircle', color: '#ff3366' },
    { name: 'Playground', route: '/experimental-playground', icon: 'Zap', color: '#ffaa00' }
  ];

  return (
    <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-30">
      {/* Central Core */}
      <div className="relative">
        {/* Outer Ring */}
        <div 
          className="w-32 h-32 rounded-full border-2 border-accent/30 animate-spin"
          style={{ 
            animationDuration: '20s',
            boxShadow: `0 0 ${20 + pulseIntensity * 20}px rgba(0, 212, 255, ${pulseIntensity})`
          }}
        >
          {/* Navigation Orbs */}
          {navigationItems?.map((item, index) => {
            const angle = (index * 72) + rotation;
            const x = Math.cos((angle * Math.PI) / 180) * 60;
            const y = Math.sin((angle * Math.PI) / 180) * 60;
            
            return (
              <button
                key={item?.route}
                className="absolute w-12 h-12 rounded-full glass-panel flex items-center justify-center group hover:scale-110 transition-all duration-300 cosmic-glow-hover"
                style={{
                  left: `calc(50% + ${x}px - 24px)`,
                  top: `calc(50% + ${y}px - 24px)`,
                  backgroundColor: `${item?.color}20`,
                  borderColor: `${item?.color}50`
                }}
                onClick={() => onNavigate(item?.route)}
              >
                <Icon 
                  name={item?.icon} 
                  size={20} 
                  className="transition-colors duration-300"
                  style={{ color: item?.color }}
                />
                {/* Tooltip */}
                <div className="absolute -top-10 left-1/2 -translate-x-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 pointer-events-none">
                  <div className="bg-background/90 text-foreground px-2 py-1 rounded text-xs font-body whitespace-nowrap border border-border/30">
                    {item?.name}
                  </div>
                </div>
              </button>
            );
          })}
        </div>

        {/* Inner Core */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div 
            className="w-16 h-16 rounded-full bg-gradient-to-br from-accent to-cosmic-energy flex items-center justify-center"
            style={{
              boxShadow: `0 0 ${30 + pulseIntensity * 30}px rgba(0, 212, 255, ${pulseIntensity * 0.8})`
            }}
          >
            <Icon name="Zap" size={24} className="text-background animate-pulse" />
          </div>
        </div>

        {/* Energy Rings */}
        <div className="absolute inset-0 pointer-events-none">
          <div 
            className="w-40 h-40 rounded-full border border-accent/20 animate-ping"
            style={{ animationDuration: '3s' }}
          ></div>
          <div 
            className="absolute inset-0 w-48 h-48 rounded-full border border-cosmic-energy/20 animate-ping"
            style={{ animationDuration: '4s', animationDelay: '1s' }}
          ></div>
        </div>
      </div>
      {/* Active Project Info */}
      {activeProject && (
        <div className="absolute top-full mt-8 left-1/2 -translate-x-1/2 w-80">
          <div className="glass-panel rounded-lg p-4 text-center">
            <h3 className="font-headline font-bold text-lg text-foreground mb-2">
              {activeProject?.title}
            </h3>
            <p className="font-body text-sm text-muted-foreground">
              {activeProject?.description}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default CentralNexus;